import { ENDPOINTS, QUERY_KEYS } from '@constants';
import { useMutationEnhancer, useQueryEnhancer } from '@hooks';
import APIManager from '@services';
import { useQueryClient } from '@tanstack/react-query';

export const useFetchCustomerPortalRequest = (id?: number | string) => {
  return useQueryEnhancer<any>({
    queryKey: [
      QUERY_KEYS.customerPortalRequest,
      id ? parseInt(id as string) : null
    ],
    queryFn: async () => {
      const res = await APIManager.request({
        url: ENDPOINTS.customerPortalRequest(':id', { id })
      });

      return res.data;
    },
    enabled: !!id
  });
};

export const useApproveCustomerPortalRequest = (id?: number | string) => {
  const queryClient = useQueryClient();

  return useMutationEnhancer({
    mutationFn: async data => {
      const res = await APIManager.request({
        url: ENDPOINTS.customerPortalRequest(':id/approve', { id }),
        method: 'POST',
        body: data,
        showToast: true
      });

      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries([
        QUERY_KEYS.customerPortalRequest,
        parseInt(id as string)
      ]);
    }
  });
};

export const useRejectCustomerPortalRequest = (id?: number | string) => {
  const queryClient = useQueryClient();

  return useMutationEnhancer<any>({
    mutationFn: async data => {
      const res = await APIManager.request({
        url: ENDPOINTS.customerPortalRequest(':id/reject', { id }),
        method: 'PUT',
        body: data,
        showToast: true
      });

      return res;
    },
    onSuccess: () => {
      queryClient.invalidateQueries([
        QUERY_KEYS.customerPortalRequest,
        parseInt(id as string)
      ]);
    }
  });
};
